<template>
  <v-form :name="props.searchProps.formName" @keyup.enter="autoSearch = true">
    <Tabs value="0" scrollable>

      <TabList class="mb-4">
        <Tab value="0">{{ __('Search condition') }}</Tab>
      </TabList>

      <TabPanels>
        <TabPanel value="0">
          <div class="grid">
            <FormInputText fieldName="name" label="Role name" size="4" :isFocus="true" v-model:field="search.name" />

            <FormMultiselect fieldName="permissions" label="Permissions" size="8" showClear
              :options="select?.permissions" :filter="(event) => onFilter(event, 'permissions')"
              v-model:field="search.permissions" />
          </div>
          <div class="grid">
            <FormTextarea fieldName="description" label="Description" row="3" v-model:field="search.description" />
          </div>
        </TabPanel>
      </TabPanels>
    </Tabs>


    <div class="grid">
      <SearchButtons :searchProps="searchProps" :search="search" v-model:autoSearch="autoSearch" />
    </div>
  </v-form>
</template>

<script setup>
import { ref } from "vue";

import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';

import FormInputText from '@crud/FormInputText.vue'
import FormMultiselect from '@crud/FormMultiselect.vue'
import FormTextarea from '@crud/FormTextarea.vue'
import SearchButtons from '@crud/SearchButtons.vue'
import { prepareSearch } from '@pages/Helper/crud_utils.js'
import { __ } from '@helper/utils.js'

// -----------------------------------------------------

const props = defineProps({
  searchProps: Object,
})
const autoSearch = ref(false)

const options = ['permissions']
const select = ref(null)

let search = ref({})
prepareSearch(search, props, options, select)

// -----------------------------------------------------

</script>

<style lang="scss" scoped></style>
